export const HOVER_LEAVE_MS = 300;
/** Stillstehen im Fenster, kürzer als das Schließen beim Verlassen. */
export const HOVER_PIN_MS = 220;

const closed = { open: false, event: null, slot: null, pinned: false, anchor: null };

export function applyHoverDialog(current, action) {
  const state = { ...closed, ...(current || {}) };
  if (action.type === 'click') {
    return { open: true, event: action.event, slot: null, pinned: true, anchor: null };
  }
  if (action.type === 'hover') {
    if (state.open && state.pinned) return state;
    return {
      open: true,
      event: action.event,
      slot: null,
      pinned: false,
      anchor: action.anchor || null,
    };
  }
  if (action.type === 'pin') {
    if (!state.open) return state;
    return { ...state, pinned: true };
  }
  if (action.type === 'leave') {
    if (!state.open || state.pinned) return state;
    return { ...closed };
  }
  return state;
}

/** true, wenn der Zeiger im Fenster ruht und dabei keinen Termin trifft. */
export function hoverPointerShouldPin(point, rect, { overBlock = false } = {}) {
  if (!point || !rect || overBlock) return false;
  const right = rect.right != null ? rect.right : rect.left + (rect.width || 0);
  const bottom = rect.bottom != null ? rect.bottom : rect.top + (rect.height || 0);
  return point.x >= rect.left && point.x <= right && point.y >= rect.top && point.y <= bottom;
}

/** Neben den Termin legen, damit der nächste Termin darunter erreichbar bleibt. */
export function hoverDialogBox(anchor, viewport) {
  if (!anchor || !viewport) return null;
  const width = 420;
  const margin = 12;
  let left = anchor.right + margin;
  if (left + width > viewport.width - margin) left = anchor.left - margin - width;
  if (left < margin) left = Math.max(margin, viewport.width - margin - width);
  const panel = Math.min(560, Math.max(160, viewport.height - margin * 2));
  let top = anchor.top;
  if (top + panel > viewport.height - margin) top = Math.max(margin, viewport.height - margin - panel);
  return { left, top, width };
}
